// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"596f52d1","87":"cbf24f85","119":"df356476","243":"8b14cc3c","440":"e8221d03","462":"16afc050","498":"96a9f533","658":"343dfdaa"}[chunkId] + ".chunk.js";
};